<template>
  <div class="search">
    <div class="search-wrapper">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="search-icon">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <el-select v-model="tempData" @change="change" filterable remote placeholder="功能搜索..."
                 :remote-method="remoteMethod" clearable :key="searchKey" class="search-select">
        <el-option v-for="item in queryList" :label="item.label" :value="item.id" :key="item.id">
          <span v-html="item.label"></span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  import {getRouteByTitle, getPermissionRoutes} from '@/router/permission'
  export default {
    name: "Search",
    model: {
      event: 'change',
    },
    data() {
      return {
        tempData: "",
        list: [],
        queryList: [],
        searchKey: ""
      }
    },
    created() {
      this.getList();
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.queryList = getRouteByTitle(query, this.list);
        } else {
          this.queryList = [];
        }
      },
      change(path) {
        this.$router.push(path).catch();
        this.queryList = [];
        this.tempData = "";
        this.searchKey = Date.now();
      },
      getList() {
        this.list = getPermissionRoutes(this.$store.state.permissions)
      },
    }
  }
</script>

<style scoped lang="scss">
  .search {
    display: flex;
    align-items: center;
    margin-left: 30px;
    animation: fadeIn 0.5s ease-out 0.15s both;
    
    .search-wrapper {
      display: flex;
      align-items: center;
      background: linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(59, 130, 246, 0.05) 100%);
      border-radius: 24px;
      padding: 4px 16px;
      border: 1px solid rgba(37, 99, 235, 0.12);
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s ease;
      }
      
      &:hover {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(59, 130, 246, 0.08) 100%);
        border-color: rgba(37, 99, 235, 0.2);
        box-shadow: 0 4px 15px rgba(37, 99, 235, 0.1);
        
        &::before {
          left: 100%;
        }
        
        .search-icon {
          color: #2563eb;
          transform: scale(1.1) rotate(10deg);
        }
      }
      
      &:focus-within {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%);
        border-color: rgba(37, 99, 235, 0.3);
        //box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
      }
      
      .search-icon {
        color: #5a5f7d;
        width: 18px;
        height: 18px;
        margin-right: 10px;
        transition: all 0.3s ease;
        flex-shrink: 0;
      }
      
      .search-select {
        width: 150px;
        
        /deep/ .el-input__inner {
          border: none;
          background: transparent!important;
          color: #374151;
          box-shadow: none!important;
          font-weight: 500;
          font-size: 14px;
          padding: 0;
          height: 25px;
          
          &::placeholder {
            color: #9ca3af;
          }
        }
        
        /deep/ .el-input__suffix {
          right: 0;
        }
      }
    }
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>
